export default function(form, selector, popupInstanse) {
    form.init({
        target        : selector,
        successMessage: true,
        popupInstanse
    });

    form.createInput({
        target: selector.querySelector('.j-input-name'),
        mode  : 'name',
        error : 'Имя должно содержать от 2 до 40 символов'
    });

    form.createInput({
        target: selector.querySelector('.j-input-phone'),
        mode  : 'phone',
        error : 'Номер  должен состоять из цифр. <br>Например: +79800000000',
        mask  : {
            regex          : '^\\+\\d{1,13}$',
            showMaskOnHover: false
        }
    });

    form.createInput({
        target: selector.querySelector('.j-input-agreement'),
        mode  : 'agreement',
        error : 'Для продолжения необходимо согласие'
    });
}
